import { render } from "./OfferEventPage.vue?vue&type=template&id=71b8360d&scoped=true"
import script from "./OfferEventPage.vue?vue&type=script&lang=js"
export * from "./OfferEventPage.vue?vue&type=script&lang=js"

import "./OfferEventPage.vue?vue&type=style&index=0&id=71b8360d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71b8360d"]])

export default __exports__